<mat-card *ngIf="orders.length > 0" class="order-list-card">
  <div class="card-header">
    <h3 class="card-title">Orders</h3>

    <div class="search-section">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search by Order Number or Customer</mat-label>
        <input
          matInput
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Enter order number or customer name..."
        />
        <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; onSearchChange()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="table-wrapper">
    <table class="order-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Order No.</th>
          <th>Customer</th>
          <th class="t-right">Items</th>
          <th class="t-right">Total</th>
          <th class="t-center">Status</th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let order of filteredOrders; let i = index"
          class="clickable-row"
          (click)="onRowClick(order)"
        >
          <td class="muted">{{ i + 1 }}</td>
          <td class="mono strong">{{ order.name }}</td>
          <td>
            <div class="customer-cell">
              <mat-icon class="avatar" aria-hidden="true">person</mat-icon>
              <span>{{ order.customerName }}</span>
            </div>
          </td>
          <td class="t-right">{{ order.numberOfItems }}</td>
          <td class="t-right mono">{{ order.totalAmount | number: '1.2-2' }}</td>
          <td class="t-center">
            <mat-chip-set>
              <mat-chip *ngIf="order.hasPostedInvoice" class="chip chip--invoiced" selected>
                <mat-icon>verified</mat-icon>
                Invoiced
              </mat-chip>
              <mat-chip *ngIf="!order.hasPostedInvoice" class="chip chip--pending" selected>
                <mat-icon>hourglass_bottom</mat-icon>
                Pending
              </mat-chip>
            </mat-chip-set>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- No results -->
    <div *ngIf="filteredOrders.length === 0 && searchTerm?.trim()" class="no-results">
      <mat-icon>search_off</mat-icon>
      <p>No orders found for “{{ searchTerm }}”</p>
      <button mat-stroked-button color="primary" (click)="searchTerm=''; onSearchChange()">Clear Filter</button>
    </div>
  </div>
</mat-card>
